/* eslint-disable line-comment-position */
import configDefault from './config/ConfigDefault';
import configDev from './config/ConfigDev';
import configLocal from './config/ConfigLocal';
import configProd from './config/ConfigProd';
import configTest from './config/ConfigTest';

/** isetting */
interface ISettings {
	title: string; // Overrides the default title
	showSettings: boolean; // Controls settings panel display
	showTagsView: boolean; // Controls tagsview display
	showSidebarLogo: boolean; // Controls siderbar logo display
	fixedHeader: boolean; // If true, will fix the header component
	errorLog: string[]; // The env to enable the errorlog component, default 'production' only
	sidebarTextTheme: boolean; // If true, will change active text color for sidebar based on theme
	devServerPort: any; // Port number for webpack-dev-server
	mockServerPort: any; // Port number for mock server
}

// log port
// console.log(configDefault.devServerPort, configDefault.mockServerPort);

/** settingas */
// You can customize below settings :)
const settings: ISettings = {
	title: 'Tencent Supplier Portal',
	showSettings: true,
	showTagsView: true,
	fixedHeader: false,
	showSidebarLogo: false,
	errorLog: ['production'],
	sidebarTextTheme: true,
	devServerPort: configDefault.devServerPort,
	mockServerPort: configDefault.mockServerPort
};

export default settings;
